import React from "react";
import Hero from "../../components/Hero/Hero";
import Clients from "../../components/Clients/Clients";
import TwoColumn from "../../components/Common/TwoColumn/TwoColumn";
import ImageGrid from "../../components/Common/ImageGrid/ImageGrid";
import Services from "../../components/Services/Services";
import Contact from "../../components/Contact/Contact";

export default function Home() {
  return (
    <>
      <Hero />
      <Clients />
      <TwoColumn />
      <ImageGrid />
      <Services />
      <Contact />
    </>
  );
}